import { useNavigate } from "react-router";
// import "./AccessDenied.scss";
import { FontIcon } from "@fluentui/react";

const NotFound = (props: any) => {
  const navigate = useNavigate();
  return (
    <div className="ad-container">
      <div className="ad-header">
        <FontIcon
          iconName="Lock"
          className="icon lock ad-scale"
        />
        <h4 className="ad-title">Not Found</h4>
      </div>
      <p className="ad-text">The page you are looking for does not exist.</p>

      <button
        className="button ad-scale"
        onClick={() => navigate(props.returnPath)}>
        Return
      </button>
    </div>
  );
};

export default NotFound;
